export default {
  delete: 'हटाएँ',
  edit: 'संशोधित करें',
  cancel: 'रद्द करें',
  clear: 'साफ़ करें',
  new: 'नया',
  update: 'अपडेट करें',
  undo: 'पूर्ववत करें',
  option: 'विकल्प',
  details: 'विवरण',
  deleting: 'हटाया जा रहा है',
  createdAt: 'बनाया गया',
  firstSeen: 'पहली बार देखा गया',
  lastActive: 'अंतिम सक्रियता',
  'idle.title': 'आपका सत्र समाप्त होने वाला है',
  'idle.content': 'अभी सत्र फिर से शुरू करें या लॉग आउट करें',
  resume: 'फिर से शुरू करें',
  name: 'नाम',
  'success.reloading': 'सफल, पृष्ठ पुनः लोड हो रहा है',
  'fail.retry': 'विफल, कृपया पुनः प्रयास करें',
  tags: 'टैग',
  after: 'बाद',
  flow: 'फ़्लो',
  text: 'टेक्स्ट',
  image: 'छवि',
  video: 'वीडियो',
  file: 'फ़ाइल',
  custom: 'कस्टम',
  input: 'इनपुट',
  quickReplies: 'त्वरित उत्तर',
  ctaUrl: 'CTA URL',
  button: 'बटन',
  question: 'प्रश्न',
  fieldRequired: 'यह फ़ील्ड आवश्यक है',
  entity: 'इकाई',
  active: 'सक्रिय',
  inactive: 'निष्क्रिय',
  deleted: 'हटाया गया',
  next: 'आगे',
  category: 'श्रेणी',
  portalUser: 'पोर्टल उपयोगकर्ता',
  role: 'भूमिका',
  admin: 'एडमिन',
  user: 'उपयोगकर्ता',
  username: 'उपयोगकर्ता नाम',
  email: 'ईमेल',
  firstName: 'पहला नाम',
  lastName: 'अंतिम नाम',
  fullName: 'पूरा नाम',
  resetPassword: 'पासवर्ड रीसेट करें',
  'resetPassword.emailSent': 'पासवर्ड रीसेट ईमेल उपयोगकर्ता को भेज दिया गया है',
  'resetPassword.confirm.title': 'इस उपयोगकर्ता का पासवर्ड रीसेट करें?',
  'resetPassword.confirm.content': '{username} ({email}) को पासवर्ड रीसेट ईमेल भेजा जाएगा',
  'resetPassword.emailFailed': 'रीसेट ईमेल भेजने में विफल, कृपया पुनः प्रयास करें',
  'resetPassword.tokenExpired': 'पासवर्ड रीसेट टोकन की अवधि समाप्त हो गई',
  oldPassword: 'वर्तमान पासवर्ड',
  newPassword: 'नया पासवर्ड',
  'password.characterNotMet': 'पासवर्ड में कम से कम एक अक्षर, एक अंक और एक विशेष वर्ण होना चाहिए',
  confirmPassword: 'पासवर्ड की पुष्टि करें',
  'confirmPassword.mismatch': 'आपके द्वारा दर्ज किए गए दोनों पासवर्ड मेल नहीं खाते!',
  unlock: 'अनलॉक करें',
  'portalUser.unlock.title': 'उपयोगकर्ता को अनलॉक करें',
  'portalUser.unlock.content':
    '{username} ({email}) - लागू होने पर उपयोगकर्ता को पासवर्ड रीसेट ईमेल भेजा जाएगा',
  'portalUser.userPasswordModal.title': 'उपयोगकर्ता पासवर्ड मोडल',
  logout: 'लॉग आउट',
  dormant: 'निष्क्रिय करें',
  'portalUser.dormant.title': 'क्या आप वाकई इस उपयोगकर्ता को निष्क्रिय करना चाहते हैं?',
  'portalUser.dormant.content':
    '{username} ({email}) - ध्यान दें कि निष्क्रिय होने के बाद यह उपयोगकर्ता इस पोर्टल तक पहुँच नहीं पाएगा',
  reactivate: 'पुनः सक्रिय करें',
  'portalUser.reactivate.title': 'क्या आप वाकई इस उपयोगकर्ता को पुनः सक्रिय करना चाहते हैं?',
  'portalUser.reactivate.content':
    '{username} ({email}) - ध्यान दें कि पुनः सक्रिय करने के बाद यह उपयोगकर्ता तुरंत इस पोर्टल तक पहुँच प्राप्त कर लेगा',
  'portalUser.delete.title': 'क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं?',
  'portalUser.delete.content':
    '{username} ({email}) - ध्यान दें कि हटाने के बाद यह उपयोगकर्ता इस पोर्टल तक पहुँच नहीं पाएगा। व्यक्तिगत डेटा मिटा दिया जाएगा; विकल्प के रूप में आप उपयोगकर्ता को निष्क्रिय भी कर सकते हैं।',
  'portalUser.delete.undo': '{username} ({email}) हटाया गया',
  'portalUser.emailChange.title': 'उपयोगकर्ता का ईमेल बदलें?',
  'portalUser.emailChange.content':
    'ईमेल {newEmail} पर अपडेट किया जाएगा और उस पते पर पासवर्ड रीसेट ईमेल भेजा जाएगा। उपयोगकर्ता लॉग आउट हो जाएगा और दोबारा लॉग इन करने के लिए उसे नया पासवर्ड सेट करना होगा।',
  'portalUser.emailChange.noEmail.content':
    'ईमेल {newEmail} पर अपडेट किया जाएगा। इस संगठन के लिए ईमेल सेवा कॉन्फ़िगर नहीं है, इसलिए एक नया पासवर्ड बनाया जाएगा और आपको दिखाया जाएगा ताकि आप उसे उपयोगकर्ता के साथ साझा कर सकें।',
  platform: 'प्लेटफ़ॉर्म',
  notes: 'नोट्स',
  'pages.review.title': 'समीक्षा',
  'pages.review.description':
    'अपनी प्रश्न सूचियों के आधार पर एक या अधिक दस्तावेज़ों की संरचित समीक्षा तैयार करें',
  'pages.login.rememberMe': 'मुझे याद रखें',
  'pages.login.forgotPassword': 'पासवर्ड भूल गए?',
  'pages.welcome.alertMessage': 'तेज़ और अधिक सक्षम हेवी-ड्यूटी कंपोनेंट जारी किए गए हैं।',
  'pages.admin.subPage.title': 'यह पृष्ठ केवल एडमिन द्वारा देखा जा सकता है',
  'pages.file.placeholder.type': 'प्रकार',
  'pages.file.placeholder.people': 'निर्माता',
  'pages.file.placeholder.search': 'फ़ाइल या फ़ोल्डर खोजें',
  'pages.file.placeholder.editfile': 'फ़ाइल का नाम बदलें',
  'pages.file.pdf': 'PDF',
  'pages.file.document': 'दस्तावेज़',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': 'टेक्स्ट',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': 'अपलोड हो रहा है',
  'pages.file.clickDragFile': 'अपलोड करने के लिए क्लिक करें या फ़ाइलें यहाँ खींचें',
  'pages.file.createfolder': 'फ़ोल्डर बनाएँ',
  'pages.file.uploadFiles': 'फ़ाइलें अपलोड करें',
  'pages.file.upload.time': 'अपलोड समय:',
  'pages.file.created.time': 'निर्माण समय:',
  'pages.file.favorites': 'मेरे पसंदीदा',
  'pages.file.history': 'संशोधन इतिहास',
  'pages.file.success': 'सफलतापूर्वक बनाया गया',
  'pages.file.filePreview': 'फ़ाइल पूर्वावलोकन',
  'pages.file.prompt.uploadFiled': 'अपलोड करने में विफल',
  'pages.file.prompt.network': 'नेटवर्क त्रुटि',
  'pages.file.prompt.fetchFiles': 'फ़ाइल सूची की जानकारी प्राप्त करने में विफल',
  'pages.file.prompt.createGroup': 'समूह बनाने में विफल',
  'pages.file.prompt.createFolderSucc': 'फ़ोल्डर सफलतापूर्वक बनाया गया',
  'pages.file.prompt.createFolderFail': 'फ़ोल्डर बनाने में विफल',
  'pages.file.prompt.updateSucc': 'सफलतापूर्वक अपडेट हुआ',
  'pages.file.prompt.updateFail': 'अपडेट करने में विफल',
  'pages.file.prompt.addFavoriteFail': 'जोड़ने में विफल',
  'pages.file.prompt.noPermission': 'आपके पास इस सत्र को संशोधित करने की अनुमति नहीं है',
  'pages.file.prompt.duplicateName': 'सत्र का नाम पहले से मौजूद है',
  'pages.file.prompt.notFound': 'सत्र नहीं मिल सका',
  'pages.file.prompt.deleteGroupSuc': 'सफलतापूर्वक हटाया गया',
  'pages.file.prompt.uploadFiles': 'फ़ाइल अपलोड के लिए तैयार है',
  'pages.file.prompt.downloadSucc': 'सफलतापूर्वक डाउनलोड हुआ',
  'pages.file.prompt.downloadFail': 'डाउनलोड करने में विफल',
  'pages.file.prompt.authFail': 'प्रमाणीकरण टोकन अनुपलब्ध है।',
  'pages.file.prompt.moveSucc': 'फ़ाइल सफलतापूर्वक स्थानांतरित हुई',
  'pages.chat.newWithUploadedDocument': 'दस्तावेज़ों के साथ नई चैट',
  'pages.chat.editSessionName': 'सत्र का नाम बदलें',
  'pages.chat.placeholder.inputSessionName': 'नया सत्र नाम दर्ज करें',
  'pages.chat.placeholder': 'जो पूछना चाहते हैं वह लिखें...',
  'pages.chat.word': '/10000 वर्ण',
  'pages.chat.rateMessage.successfulLike': 'संदेश को सफलतापूर्वक पसंद किया गया',
  'pages.chat.rateMessage.successfulDislike': 'संदेश को सफलतापूर्वक नापसंद किया गया',
  'pages.chat.actions.like': 'अच्छी प्रतिक्रिया',
  'pages.chat.actions.dislike': 'खराब प्रतिक्रिया',
  'pages.chat.rateMessage.error': 'संदेश को रेट करने में विफल',
  'pages.chat.selectContext.setFilePriority.success': 'फ़ाइल प्राथमिकता सफलतापूर्वक अपडेट हुई',
  'pages.chat.selectContext.setFilePriority.error': 'फ़ाइल प्राथमिकता अपडेट करने में त्रुटि',
  'pages.chat.selectContext.toolTipDefault':
    'डिफ़ॉल्ट रूप से, बॉट के पास उन सभी फ़ाइलों तक पहुँच होगी जिन तक आपकी पहुँच है।',
  'pages.chat.rerank':
    'परिणाम लौटाने से पहले खोज परिणामों को दूसरी बार क्रमबद्ध करता है। इससे परिणामों की गुणवत्ता बेहतर हो सकती है, लेकिन खोज काफ़ी धीमी हो जाती है।',
  'pages.chat.selectContext.tootlTipRestrict':
    'आप इस मेन्यू से मॉडल को उपलब्ध कराई जाने वाली फ़ाइलों को सीमित कर सकते हैं।',
  'pages.chat.hybridSearchAlphaTooltip':
    'खोज अनुपात सिमेंटिक और कीवर्ड खोज के बीच संतुलन तय करता है। कम मान कीवर्ड खोज को और अधिक मान सिमेंटिक खोज को प्राथमिकता देते हैं।',
  'pages.chat.favoriteFileWeight':
    'यह भार पसंदीदा फ़ाइलों की खोज रैंकिंग को कृत्रिम रूप से बढ़ाता है।',
  'pages.dashboard.realTimeUsersTitleTooltip':
    'उन उपयोगकर्ताओं की संख्या जो इस समय बॉट से बातचीत कर रहे हैं या पिछले 5 मिनट में कर चुके हैं।',
  'pages.dashboard.activeUsersTitleTooltip':
    'चयनित अवधि के दौरान बॉट से बातचीत करने वाले उपयोगकर्ताओं की संख्या।',
  'pages.dashboard.newUsersTitleTooltip':
    'चयनित अवधि के दौरान पहली बार बॉट से बातचीत करने वाले उपयोगकर्ताओं की संख्या।',
  'pages.dashboard.promptTokensTitleTooltip':
    'चयनित अवधि के दौरान प्रोसेस किए गए इनपुट टोकन की संख्या।',
  'pages.dashboard.completionTokensTitleTooltip':
    'चयनित अवधि के दौरान उत्पन्न आउटपुट टोकन की संख्या।',
  'pages.dashboard.userMessagesTitleTooltip':
    'चयनित अवधि के दौरान उपयोगकर्ताओं द्वारा भेजे गए संदेशों की संख्या।',
  'pages.dashboard.storyboardsTitleTooltip':
    'चयनित अवधि के दौरान पूर्व-निर्मित चैटबॉट स्टोरीबोर्ड द्वारा संभाले गए उपयोगकर्ता संदेशों की संख्या।',
  'pages.dashboard.botMessagesTitleTooltip':
    'चयनित अवधि के दौरान बॉट द्वारा उपयोगकर्ताओं को भेजे गए संदेशों की संख्या।',
  'pages.dashboard.broadcastsTitleTooltip':
    'चयनित अवधि के दौरान ब्रॉडकास्ट फ़ंक्शन के माध्यम से बॉट द्वारा उपयोगकर्ताओं को भेजे गए संदेशों की संख्या।',
  'pages.dashboard.repliesTitleTooltip':
    'चयनित अवधि के दौरान उपयोगकर्ता संदेशों के उत्तर में उपयोगकर्ताओं को भेजे गए संदेशों की संख्या।',
  'pages.dashboard.messageExchangesTitleTooltip':
    'चयनित अवधि के दौरान उपयोगकर्ताओं और बॉट के बीच आदान-प्रदान किए गए संदेशों की संख्या।',
  'pages.dashboard.broadcastTitleTooltip':
    'चयनित अवधि के दौरान बॉट द्वारा आरंभ किए गए ब्रॉडकास्ट की संख्या।',
  'pages.dashboard.outReachTitleTooltip':
    'चयनित अवधि के सभी ब्रॉडकास्ट के प्राप्तकर्ताओं की कुल संख्या।',
  'pages.chat.stopGenerating': 'जनरेट करना रोक दिया गया।',
  'pages.chat.stopGenerating.error': 'जनरेट करना रोकने में विफल।',
  'pages.app.timeline': 'समयरेखा',
  'pages.app.guided_summary': 'निर्देशित सारांश',
  'pages.app.standard_info': 'त्वरित जानकारी',
  'pages.app.addCustomFieldsTitle': 'प्रत्येक घटना के लिए निकाले जाने वाले कस्टम फ़ील्ड जोड़ें',
  'pages.app.addCustomStepButton': 'कस्टम चरण जोड़ें',
  'pages.app.addFieldButton': 'फ़ील्ड जोड़ें',
  'pages.app.addFromLibraryButton': 'लाइब्रेरी से जोड़ें',
  'pages.app.addToMattersButton': 'मैटर में जोड़ें',
  'pages.app.analysisType.agenticResearch.description':
    'चयनित दस्तावेज़ों और अपलोड की गई फ़ाइलों का अन्वेषण करता है, फिर उद्धरणों सहित एक व्यापक उत्तर तैयार करता है।',
  'pages.app.analysisType.agenticResearch.title': 'एजेंटिक रिसर्च',
  'pages.app.analysisType.comparison.description':
    'दो दस्तावेज़ों की तुलना करता है और अंतर बताने वाली रिपोर्ट देता है। तुलना को लक्षित करने के लिए आप प्रॉम्प्ट दे सकते हैं।',
  'pages.app.analysisType.comparison.title': 'तुलना',
  'pages.app.analysisType.contractDeadlines.description':
    "अनुबंध/दस्तावेज़ में पाई गई सभी समय-सीमाएँ, महत्वपूर्ण तिथियाँ और अवधियाँ सूचीबद्ध करता है। क्लाइंट का विवरण देना मददगार होता है (जैसे 'क्लाइंट एक सिंगापुरी बैंक है जो ई-बैंकिंग सेवाओं में विशेषज्ञता रखता है')",
  'pages.app.analysisType.contractDeadlines.title': 'समय-सीमाएँ निकालें',
  'pages.app.analysisType.executiveSummary.description':
    'प्रमुख सलाह, मुद्दों, जोखिमों और कार्रवाइयों का संक्षिप्त कार्यकारी सारांश प्रस्तुत करता है।',
  'pages.app.analysisType.executiveSummary.title': 'कार्यकारी सारांश',
  'pages.app.analysisType.gartnerReport.description':
    'पूर्वानुमानों और सिफ़ारिशों सहित एक गहन उद्योग रिपोर्ट प्रस्तुत करता है।',
  'pages.app.analysisType.gartnerReport.title': 'Gartner-शैली रिपोर्ट',
  'pages.app.analysisType.guidedSummary.description':
    'प्रॉम्प्ट के निर्देशानुसार किसी एक दस्तावेज़ का विस्तृत सारांश प्रस्तुत करता है।',
  'pages.app.analysisType.multiStepPrompt.description':
    'कई प्रॉम्प्ट क्रमिक रूप से चलाता है, हर चरण के आउटपुट पर आगे निर्माण करते हुए।',
  'pages.app.analysisType.multiStepPrompt.title': 'बहु-चरणीय प्रॉम्प्ट',
  'pages.app.analysisType.scopeOfWork.description':
    'सहायता या सेवाओं के अनुरोध वाला क्लाइंट का ईमेल, पत्र या RFP अपलोड करें या चुनें। "प्रॉम्प्ट" में क्लाइंट का विवरण देना मददगार होता है (जैसे \'क्लाइंट एक सिंगापुरी बैंक है जो ई-बैंकिंग सेवाओं में विशेषज्ञता रखता है\')',
  'pages.app.analysisType.scopeOfWork.title': 'कार्य-क्षेत्र सारांश',
  'pages.app.analysisType.standardInfo.description':
    'एक संक्षिप्त सारांश, महत्वपूर्ण व्यक्तियों व इकाइयों की सूची और घटनाओं की संक्षिप्त समयरेखा प्रस्तुत करता है। आप अधिकतम 100 दस्तावेज़ दे सकते हैं।',
  'pages.app.analysisType.timeline.description':
    'अधिकतम 100 दस्तावेज़ों में घटनाओं की विस्तृत समयरेखा प्रस्तुत करता है।',
  'pages.app.analyzingFiles': 'फ़ाइलों का विश्लेषण हो रहा है...',
  'pages.app.applicablePartiesColumnTitle': 'संबंधित पक्ष',
  'pages.app.appsInstructions':
    'काम करने के लिए कई फ़ाइलें चुनें और फिर नीचे दी गई सूची से विश्लेषण का प्रकार चुनें। अनुरोध प्रोसेस होने में लगभग 1-5 मिनट लगते हैं।',
  'pages.app.appsList.agenticResearch.description':
    'चयनित दस्तावेज़ों और अपलोड की गई फ़ाइलों का अन्वेषण करता है, फिर उद्धरणों सहित एक व्यापक उत्तर तैयार करता है।',
  'pages.app.appsList.contractDeadlines.description':
    'अनुबंध/दस्तावेज़ में पाई गई सभी समय-सीमाएँ, महत्वपूर्ण तिथियाँ और अवधियाँ सूचीबद्ध करता है।',
  'pages.app.appsList.executiveSummary.description':
    'नेतृत्व के लिए प्रमुख बिंदुओं, निष्कर्षों और सिफ़ारिशों का उच्च-स्तरीय अवलोकन',
  'pages.app.appsList.gartnerReport.description':
    'आत्मविश्वासपूर्ण और वस्तुनिष्ठ शोध पद्धति का उपयोग करते हुए गहन उद्योग विश्लेषण',
  'pages.app.appsList.guidedSummary.description':
    'प्रॉम्प्ट के निर्देशानुसार किसी एक दस्तावेज़ का विस्तृत सारांश प्रस्तुत करता है',
  'pages.app.appsList.multiStepPrompt.description':
    'कई प्रॉम्प्ट क्रमिक रूप से चलाता है, हर चरण के आउटपुट पर आगे निर्माण करते हुए',
  'pages.app.appsList.scopeOfWork.description':
    'सहायता या सेवाओं के अनुरोध वाला क्लाइंट का ईमेल, पत्र या RFP अपलोड करें या चुनें।',
  'pages.app.appsList.standardInfo.description':
    'एक संक्षिप्त सारांश, व्यक्तियों व इकाइयों की सूची और संक्षिप्त समयरेखा प्रस्तुत करता है',
  'pages.app.appsList.timeline.description':
    'अधिकतम 100 दस्तावेज़ों में घटनाओं की विस्तृत समयरेखा प्रस्तुत करता है',
  'pages.app.appsTitle': 'ऐप्स',
  'pages.app.backgroundColumnTitle': 'पृष्ठभूमि',
  'pages.app.buildMultiStepPromptTitle': 'अपना बहु-चरणीय प्रॉम्प्ट बनाएँ',
  'pages.app.clauseColumnTitle': 'खंड',
  'pages.app.clientDetailsPlaceholder': 'क्लाइंट का नाम और संक्षिप्त विवरण',
  'pages.app.clientInformationTitle': 'क्लाइंट जानकारी',
  'pages.app.clientLabel': 'क्लाइंट',
  'pages.app.collapseAllPrompts': 'सभी प्रॉम्प्ट संक्षिप्त करें',
  'pages.app.collapsePrompt': 'प्रॉम्प्ट संक्षिप्त करें',
  'pages.app.compilingFinalSummary': 'अंतिम सारांश तैयार किया जा रहा है...',
  'pages.app.complexityLabel': 'जटिलता',
  'pages.app.configNameLabel': 'कॉन्फ़िग नाम',
  'pages.app.configurationDeletedSuccess': 'कॉन्फ़िगरेशन हटाया गया',
  'pages.app.configurationSavedSuccess': 'कॉन्फ़िगरेशन सफलतापूर्वक सहेजा गया',
  'pages.app.configurationUpdatedSuccess': 'कॉन्फ़िगरेशन सफलतापूर्वक अपडेट हुआ',
  'pages.app.contactLabel': 'संपर्क',
  'pages.app.counterpartyLabel': 'प्रतिपक्ष',
  'pages.app.dateReferenceColumnTitle': 'दिनांक/संदर्भ',
  'pages.app.deadlinesSectionTitle': 'समय-सीमाएँ',
  'pages.app.deleteConfigConfirmTitle': 'क्या आप वाकई इस कॉन्फ़िगरेशन को हटाना चाहते हैं?',
  'pages.app.deleteStepTooltip': 'चरण हटाएँ',
  'pages.app.detailsColumnTitle': 'विवरण',
  'pages.app.doneCount': 'पूर्ण ({completed}/{total})',
  'pages.app.dragHereToUpload': 'अपलोड करने के लिए यहाँ खींचें',
  'pages.app.dragStepTooltip': 'चरण खींचें',
  'pages.app.dropZoneForNamedStep': '{stepName} के लिए ड्रॉप क्षेत्र',
  'pages.app.dropZoneForStepNumber': 'चरण {stepNumber} के लिए ड्रॉप क्षेत्र',
  'pages.app.durationColumnTitle': 'अवधि',
  'pages.app.enterConfigNamePlaceholder': 'कॉन्फ़िग नाम दर्ज करें',
  'pages.app.enterDescriptionPlaceholder': 'विवरण दर्ज करें',
  'pages.app.entitiesColumnTitle': 'इकाइयाँ',
  'pages.app.expandAllPrompts': 'सभी प्रॉम्प्ट विस्तृत करें',
  'pages.app.expandPrompt': 'प्रॉम्प्ट विस्तृत करें',
  'pages.app.extendPromptTabLabel': 'प्रॉम्प्ट विस्तारित करें',
  'pages.app.extraFieldDescriptionPlaceholder': 'विवरण (जैसे उल्लिखित मौद्रिक मूल्य निकालें)',
  'pages.app.extraFieldKeyPlaceholder': 'कुंजी (जैसे बजट)',
  'pages.app.extractColumnTitle': 'निकालें',
  'pages.app.extractDeadlinesModalDescription':
    "अनुबंध/दस्तावेज़ में पाई गई सभी समय-सीमाएँ, महत्वपूर्ण तिथियाँ और अवधियाँ सूचीबद्ध करता है। क्लाइंट का विवरण देना मददगार होता है (जैसे 'क्लाइंट एक सिंगापुरी बैंक है जो ई-बैंकिंग सेवाओं में विशेषज्ञता रखता है')",
  'pages.app.fileCountLabel': '{count} फ़ाइल',
  'pages.app.filesCompleteCount': '{total} में से {completed} फ़ाइलें पूर्ण',
  'pages.app.hardDeadlineColumnTitle': 'अंतिम समय-सीमा',
  'pages.app.inProgressSuffix': ' (प्रगति पर)',
  'pages.app.keyDatesDeadlinesTitle': 'प्रमुख तिथियाँ और समय-सीमाएँ',
  'pages.app.loadSavedConfigPlaceholder': 'सहेजा गया कॉन्फ़िग लोड करें',
  'pages.app.loadingDocumentTip': 'दस्तावेज़ लोड हो रहा है...',
  'pages.app.mattersUpdatedSuccess': 'मैटर सफलतापूर्वक अपडेट हुए',
  'pages.app.moveStepDownTooltip': 'नीचे ले जाएँ',
  'pages.app.moveStepUpTooltip': 'ऊपर ले जाएँ',
  'pages.app.newAnalysisModesDescription':
    'हमने दो नए सशक्त विश्लेषण मोड जोड़े हैं ताकि आप अपने अनुबंधों से और अधिक मूल्य प्राप्त कर सकें।',
  'pages.app.newAnalysisModesTitle': 'नए विश्लेषण मोड',
  'pages.app.newFieldDefaultKey': 'फ़ील्ड {number}',
  'pages.app.newSessionLabel': 'नया सत्र',
  'pages.app.newStepDefaultName': 'नया चरण',
  'pages.app.noSourceDocumentsDescription': 'कोई स्रोत दस्तावेज़ नहीं',
  'pages.app.noTimelineItemsExtracted': 'कोई समयरेखा आइटम नहीं निकाला गया।',
  'pages.app.overallTabLabel': 'समग्र',
  'pages.app.overviewSectionTitle': 'अवलोकन',
  'pages.app.partiesSectionTitle': 'पक्ष',
  'pages.app.peopleEntitiesInvolvedLabel': 'संबंधित व्यक्ति / इकाइयाँ',
  'pages.app.periodsDurationsTitle': 'कालावधि और अवधियाँ',
  'pages.app.pleaseEnterPlaceholder': 'कृपया दर्ज करें',
  'pages.app.processingNextStep': 'अगला चरण प्रोसेस हो रहा है...',
  'pages.app.promptForStepPlaceholder': 'इस चरण के लिए प्रॉम्प्ट',
  'pages.app.promptLabelWithValue': 'प्रॉम्प्ट: {prompt}',
  'pages.app.provideDetailsTabLabel': 'विवरण दें',
  'pages.app.provideDocumentsTabLabel': 'दस्तावेज़ दें',
  'pages.app.providePromptsTabLabel': 'प्रॉम्प्ट दें',
  'pages.app.provisionColumnTitle': 'प्रावधान',
  'pages.app.publishAudienceGroupsLabel': 'समूह',
  'pages.app.publishAudienceLabel': 'दर्शक',
  'pages.app.publishAudienceOptionFirmWide': 'पूरी फ़र्म',
  'pages.app.publishAudienceOptionGroup': 'समूह',
  'pages.app.publishAudienceOptionPublic': 'सार्वजनिक',
  'pages.app.publishButton': 'प्रकाशित करें',
  'pages.app.publishConfigTitle': 'कॉन्फ़िग प्रकाशित करें',
  'pages.app.publishFirmWideNotice':
    'यह कॉन्फ़िग आपके संगठन के सभी लोगों के साथ साझा किया जाएगा। अनुमोदन के लिए संगठन एडमिन को अनुरोध भेजा जाएगा।',
  'pages.app.publishPublicNotice':
    'यह कॉन्फ़िग सभी उपयोगकर्ताओं को दिखाई देगा। अनुमोदन के लिए सुपर एडमिन को अनुरोध भेजा जाएगा।',
  'pages.app.publishRequestSubmitted': 'प्रकाशन अनुरोध सबमिट हुआ — एडमिन अनुमोदन की प्रतीक्षा है',
  'pages.app.publishedToGroup': 'समूह में प्रकाशित',
  'pages.app.readingDocumentName': '{name} पढ़ा जा रहा है',
  'pages.app.restrictionColumnTitle': 'प्रतिबंध',
  'pages.app.restrictiveCovenantsTitle': 'प्रतिबंधात्मक अनुबंध-शर्तें',
  'pages.app.reuseButton': 'पुनः उपयोग करें',
  'pages.app.runAppButton': 'ऐप चलाएँ',
  'pages.app.sanitizedCheckingDocuments': 'दस्तावेज़ जाँचे जा रहे हैं…',
  'pages.app.sanitizedSearchingDocuments': 'दस्तावेज़ खोजे जा रहे हैं…',
  'pages.app.sanitizedWorkingThroughDocuments': 'दस्तावेज़ों पर काम हो रहा है…',
  'pages.app.saveConfigButton': 'कॉन्फ़िग सहेजें',
  'pages.app.saveConfigurationTitle': 'कॉन्फ़िगरेशन सहेजें',
  'pages.app.scopeOfWorkModalDescription':
    'सहायता या सेवाओं के अनुरोध वाला क्लाइंट का ईमेल, पत्र या RFP अपलोड करें या चुनें। "प्रॉम्प्ट" में क्लाइंट का विवरण देना मददगार होता है (जैसे \'क्लाइंट एक सिंगापुरी बैंक है जो ई-बैंकिंग सेवाओं में विशेषज्ञता रखता है\')',
  'pages.app.searchMattersPlaceholder': 'मैटर खोजें...',
  'pages.app.searchPromptsPlaceholder': 'प्रॉम्प्ट खोजें...',
  'pages.app.selectAtLeastOneGroupError': 'कम से कम एक समूह चुनें',
  'pages.app.selectDocumentsStepTitle': '1. वे दस्तावेज़ चुनें जिनका आप विश्लेषण करना चाहते हैं',
  'pages.app.selectMattersLabel': 'मैटर चुनें:',
  'pages.app.sharedConfigLabel': '{name} (साझा)',
  'pages.app.sourcesColumnTitle': 'स्रोत',
  'pages.app.specialRequestsSectionTitle': 'विशेष अनुरोध',
  'pages.app.specificInformationStepTitle': '2. विशिष्ट जानकारी (वैकल्पिक)',
  'pages.app.stepNamePlaceholder': 'चरण का नाम (जैसे इकाइयाँ निकालें)',
  'pages.app.stepNumberLabel': 'चरण {number}',
  'pages.app.subagentLabel': 'सबएजेंट {number}',
  'pages.app.subjectLabel': 'विषय',
  'pages.app.summaryLabel': 'सारांश',
  'pages.app.timelineFieldsDescription':
    'वे अतिरिक्त कॉलम परिभाषित करें जो आप समयरेखा में देखना चाहते हैं। प्रत्येक फ़ील्ड के लिए एक कुंजी (कॉलम शीर्षक) और यह विवरण दें कि कौन-सी जानकारी निकालनी है।',
  'pages.app.tool.checkingDocuments': 'दस्तावेज़ जाँचे जा रहे हैं',
  'pages.app.tool.readingDocument': 'दस्तावेज़ पढ़ा जा रहा है',
  'pages.app.tool.searchingDocuments': 'दस्तावेज़ खोजे जा रहे हैं',
  'pages.app.tool.workingWithName': 'काम जारी ({name})',
  'pages.app.tool.writingReport': 'रिपोर्ट लिखी जा रही है',
  'pages.app.untitledSession': '(शीर्षकहीन)',
  'pages.app.updateConfigButton': 'अपडेट करें',
  'pages.app.updateConfigurationTitle': 'कॉन्फ़िगरेशन अपडेट करें',
  'pages.app.updateMattersFailed': 'मैटर अपडेट करने में विफल',
  'pages.app.uploadOrSelectFilesError': 'कृपया फ़ाइलें अपलोड करें या मौजूदा फ़ाइलें चुनें',
  'pages.app.urgencyColumnTitle': 'तात्कालिकता',
  'pages.app.useAnotherAppButton': 'दूसरा ऐप उपयोग करें',
  'pages.app.whatsNew': 'नया क्या है',
  'pages.app.workingEllipsis': 'काम जारी…',
  'pages.app.workingThroughDocumentsCount': 'दस्तावेज़ों पर काम हो रहा है ({completed}/{total})',
  'pages.login.microsoftSSO': 'Microsoft से साइन इन करें',
  'pages.login.loading': 'लोड हो रहा है...',
  'pages.login.redirectingToMS': 'Microsoft SSO पर भेजा जा रहा है...',
  'pages.loggedOut.title': 'साइन आउट हो गए',
  'pages.loggedOut.heading': 'आप साइन आउट हो चुके हैं',
  'pages.loggedOut.description':
    'आप यह विंडो बंद कर सकते हैं या दोबारा साइन इन करने के लिए लॉगिन पृष्ठ पर लौट सकते हैं।',
  'pages.loggedOut.return': 'लॉगिन पर वापस जाएँ',
  'pages.projectsHub.func.chat': 'चैट',
  'pages.projectsHub.func.scribe': 'स्क्राइब',
  'pages.projectsHub.func.apps': 'ऐप्स',
  'pages.projectsHub.func.review': 'समीक्षा',
  'pages.projectsHub.func.sideBySide': 'साथ-साथ',
  'pages.projectsHub.func.comparison': 'तुलना',
  'pages.projectsHub.func.translation': 'अनुवाद',
  'pages.projectsHub.func.template': 'कस्टम आउटपुट',
  'pages.projectsHub.func.quote': 'कोट',
  'pages.projectsHub.untitledSession': 'शीर्षकहीन',
  'pages.projectsHub.untitledFileLabel': '(शीर्षकहीन)',
  'pages.projectsHub.errors.loadDataFailed': 'डेटा लोड करने में विफल',
  'pages.projectsHub.subfolderCreated': 'उपफ़ोल्डर बनाया गया',
  'pages.projectsHub.collectionCreated': 'संग्रह बनाया गया',
  'pages.projectsHub.errors.createFailed': 'बनाने में विफल',
  'pages.projectsHub.errors.updateFailed': 'अपडेट करने में विफल',
  'pages.projectsHub.deleteCollectionConfirm.title': 'संग्रह हटाएँ',
  'pages.projectsHub.deleteCollectionConfirm.content': '"{name}" हटाएँ?',
  'pages.projectsHub.collectionDeleted': 'हटाया गया',
  'pages.projectsHub.errors.deleteFailed': 'विफल',
  'pages.projectsHub.sessionsAdded': '{count} सत्र जोड़े गए',
  'pages.projectsHub.errors.addSessionsFailed': 'जोड़ने में विफल',
  'pages.projectsHub.sessionRemoved': 'सत्र हटाया गया',
  'pages.projectsHub.errors.removeSessionFailed': 'सत्र हटाने में विफल',
  'pages.projectsHub.sessionsRemoved': '{count} सत्र हटाए गए',
  'pages.projectsHub.errors.removeSessionsFailed': 'सत्र हटाने में विफल',
  'pages.projectsHub.fieldSaved': 'सहेजा गया',
  'pages.projectsHub.errors.saveFieldFailed': 'सहेजने में विफल',
  'pages.projectsHub.folderDeleted': 'फ़ोल्डर हटाया गया',
  'pages.projectsHub.errors.deleteFolderFailed': 'फ़ोल्डर हटाने में विफल',
  'pages.projectsHub.folderCreated': 'फ़ोल्डर बनाया गया',
  'pages.projectsHub.errors.createFolderFailed': 'फ़ोल्डर बनाने में विफल',
  'pages.projectsHub.deleteFolderConfirm.description': '"{name}" और उसकी सारी सामग्री हटाएँ?',
  'pages.projectsHub.deleteSessionsConfirm.title': 'सत्र हटाएँ',
  'pages.projectsHub.deleteSessionsConfirm.description': 'इस संग्रह से {count} सत्र हटाएँ?',
  'pages.projectsHub.removeSessionConfirm.title': 'सत्र हटाएँ',
  'pages.projectsHub.removeSessionConfirm.description': 'इस संग्रह से "{name}" हटाएँ?',
  'pages.projectsHub.sort.newestFirst': 'पहले नए',
  'pages.projectsHub.sort.oldestFirst': 'पहले पुराने',
  'pages.projectsHub.sort.nameAsc': 'नाम (A-Z)',
  'pages.projectsHub.sort.nameDesc': 'नाम (Z-A)',
  'pages.projectsHub.doubleClickToOpen': 'खोलने के लिए डबल-क्लिक करें',
  'pages.projectsHub.tidyUp': 'व्यवस्थित करें',
  'pages.projectsHub.exit': 'बाहर निकलें',
  'pages.projectsHub.manage': 'प्रबंधित करें',
  'pages.projectsHub.deleteSessionsButton': 'हटाएँ ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': 'सत्र खोजें',
  'pages.projectsHub.emptyState.noFiles': 'कोई फ़ाइल नहीं',
  'pages.projectsHub.newFolderButton': 'नया फ़ोल्डर',
  'pages.projectsHub.addSessionsButton': 'सत्र जोड़ें',
  'pages.projectsHub.folderInfoLabel': 'फ़ोल्डर जानकारी',
  'pages.projectsHub.mattersHeading': 'मैटर',
  'pages.projectsHub.mattersSubtitle':
    'संग्रह बनाएँ और अलग-अलग फ़ंक्शन के सत्रों को एक ही वर्कस्पेस में व्यवस्थित करें।',
  'pages.projectsHub.hubBreadcrumbLabel': 'हब',
  'pages.projectsHub.deleteFolderButton': 'फ़ोल्डर हटाएँ',
  'pages.projectsHub.itemsLabel': 'आइटम',
  'pages.projectsHub.selectSubfolderEmptyState': 'विवरण देखने के लिए कोई उपफ़ोल्डर चुनें',
  'pages.projectsHub.selectFolderEmptyState': 'विवरण देखने के लिए कोई फ़ोल्डर चुनें',
  'pages.projectsHub.noCollectionsMatch': 'आपके वर्तमान फ़िल्टर से कोई संग्रह मेल नहीं खाता।',
  'pages.projectsHub.noSessionsFoundForFunction': 'कोई {func} सत्र नहीं मिला।',
  'pages.projectsHub.addSelectedSessionsButton':
    '{count, plural, =0 {चयनित जोड़ें} one {# सत्र जोड़ें} other {# सत्र जोड़ें}}',
  'pages.projectsHub.step1ChooseFunctionType': 'चरण 1 — फ़ंक्शन का प्रकार चुनें',
  'pages.projectsHub.selectFunctionPlaceholder': 'फ़ंक्शन चुनें',
  'pages.projectsHub.step2SelectSessions': 'चरण 2 — जोड़ने के लिए सत्र चुनें',
  'pages.projectsHub.createFolderButton': 'फ़ोल्डर बनाएँ',
  'pages.projectsHub.folderNameLabel': 'फ़ोल्डर का नाम',
  'pages.projectsHub.subfolderNamePlaceholder': 'जैसे ड्यू डिलिजेंस',
  'pages.projectsHub.collectionNamePlaceholder': 'जैसे M&A ड्यू डिलिजेंस',
  'pages.projectsHub.optionalDescriptionPlaceholder': 'वैकल्पिक विवरण',
  'pages.projectsHub.optionalNotesPlaceholder': 'वैकल्पिक नोट्स',
  'pages.projectsHub.createCollectionModalTitle': 'संग्रह बनाएँ',
  'pages.projectsHub.collectionNameLabel': 'संग्रह का नाम',
  'pages.projectsHub.editCollectionModalTitle': 'संपादित करें • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {# आइटम} other {# आइटम}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {# फ़ाइल} other {# फ़ाइलें}}',
  'pages.sideBySide.addAtLeastOneQuestion': 'कृपया कम से कम एक प्रश्न जोड़ें',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    'सबमिट करने से पहले कृपया कम से कम एक प्रश्न जोड़ें।',
  'pages.sideBySide.addNewQuestionsPlaceholder': 'नए प्रश्न जोड़ें (प्रति पंक्ति एक)',
  'pages.sideBySide.addPlusButton': 'जोड़ें +',
  'pages.sideBySide.addQuestionsLabel': 'प्रश्न जोड़ें',
  'pages.sideBySide.addToMattersButton': 'मैटर में जोड़ें',
  'pages.sideBySide.authorFieldLabel': 'लेखक',
  'pages.sideBySide.authorLabel': 'लेखक: ',
  'pages.sideBySide.categoryLabel': 'श्रेणी',
  'pages.sideBySide.cellDetails.answer': 'उत्तर',
  'pages.sideBySide.cellDetails.verified': 'सत्यापित',
  'pages.sideBySide.cellDetails.verify': 'सत्यापित करें',
  'pages.sideBySide.cellMarkedUnverified': 'सेल को असत्यापित चिह्नित किया गया',
  'pages.sideBySide.cellMarkedVerified': 'सेल को सत्यापित चिह्नित किया गया',
  'pages.sideBySide.cellUpdatedSuccess': 'सेल सफलतापूर्वक अपडेट हुई',
  'pages.sideBySide.changesUndone': 'बदलाव पूर्ववत किए गए',
  'pages.sideBySide.clickOrDragToUpload': 'अपलोड करने के लिए क्लिक करें या खींचें',
  'pages.sideBySide.cloneButton': 'प्रतिलिपि बनाएँ',
  'pages.sideBySide.cloneModeLabel': 'प्रतिलिपि',
  'pages.sideBySide.clonedNamePrefix': 'प्रतिलिपि - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    'नया कॉलम जोड़ा गया। मैट्रिक्स शीघ्र ही रीफ़्रेश होगा।',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    'कॉलम अपडेट शुरू हुआ। कॉलम शीघ्र ही रीफ़्रेश होगा।',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'कृपया कोई प्रॉम्प्ट दर्ज करें।',
  'pages.sideBySide.columnEditModal.promptLabel': 'प्रॉम्प्ट',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    'इस कॉलम के लिए प्रॉम्प्ट/सिस्टम निर्देश का विवरण दें',
  'pages.sideBySide.columnEditModal.title': 'कॉलम संशोधित करें',
  'pages.sideBySide.columnEditModal.updateColumnFailed': 'कॉलम अपडेट करने में विफल',
  'pages.sideBySide.createCustomQuestionListDescription':
    'इस सत्र के लिए कस्टम साथ-साथ प्रश्न सूची बनाएँ',
  'pages.sideBySide.createModeLabel': 'बनाएँ',
  'pages.sideBySide.createQuestionListButton': 'प्रश्न सूची बनाएँ',
  'pages.sideBySide.createdByLabel': 'बनाने वाला: ',
  'pages.sideBySide.createdByYou': 'आप',
  'pages.sideBySide.customInstructionOptional': '2. कस्टम निर्देश (वैकल्पिक)',
  'pages.sideBySide.deleteQuestionListConfirm': 'क्या आप वाकई इस प्रश्न सूची को हटाना चाहते हैं?',
  'pages.sideBySide.dragHereToUpload': 'अपलोड करने के लिए यहाँ खींचें',
  'pages.sideBySide.emailButton': 'ईमेल',
  'pages.sideBySide.exitButton': 'बाहर निकलें',
  'pages.sideBySide.exitModeButton': '{mode} से बाहर निकलें',
  'pages.sideBySide.fileCount': '{count} फ़ाइल',
  'pages.sideBySide.firmOption': 'फ़र्म',
  'pages.sideBySide.firmWideOption': 'पूरी फ़र्म',
  'pages.sideBySide.fromDocumentOption': 'दस्तावेज़ से',
  'pages.sideBySide.groupOption': 'समूह',
  'pages.sideBySide.leadRowHeader': 'स्रोत दस्तावेज़ के अनुच्छेद',
  'pages.sideBySide.manualCraftOption': 'मैन्युअल रूप से बनाएँ',
  'pages.sideBySide.modifyButton': 'संशोधित करें',
  'pages.sideBySide.modifyModeLabel': 'संशोधन',
  'pages.sideBySide.newCategoryPlaceholder': 'नई श्रेणी',
  'pages.sideBySide.newQuestionListButtonLabel': 'नई साथ-साथ प्रश्न सूची',
  'pages.sideBySide.newQuestionListDefaultName': 'नई साथ-साथ प्रश्न सूची',
  'pages.sideBySide.noNotesAvailable': 'कोई नोट्स उपलब्ध नहीं।',
  'pages.sideBySide.noPurposeAvailable': 'कोई उद्देश्य उपलब्ध नहीं।',
  'pages.sideBySide.noSystemPromptConfigured': 'कोई सिस्टम प्रॉम्प्ट कॉन्फ़िगर नहीं किया गया।',
  'pages.sideBySide.notesFieldLabel': 'नोट्स',
  'pages.sideBySide.notesLabel': 'नोट्स: ',
  'pages.sideBySide.pendingApprovalTag': 'अनुमोदन लंबित',
  'pages.sideBySide.pollingTimeoutWarning':
    'पोलिंग टाइमआउट। साथ-साथ तुलना अभी भी प्रोसेस हो रही हो सकती है।',
  'pages.sideBySide.processing': 'प्रोसेस हो रहा है',
  'pages.sideBySide.processingStopped': 'प्रोसेसिंग रोक दी गई।',
  'pages.sideBySide.publicOption': 'सार्वजनिक',
  'pages.sideBySide.publishButton': 'प्रकाशित करें',
  'pages.sideBySide.publishQuestionListFailed': 'प्रश्न सूची प्रकाशित करने में विफल',
  'pages.sideBySide.publishStatusLabel': 'प्रकाशन स्थिति',
  'pages.sideBySide.publishToLabel': 'यहाँ प्रकाशित करें:',
  'pages.sideBySide.publishedToAccess': '{access} में प्रकाशित',
  'pages.sideBySide.publishedToGroupSuccess': 'प्रश्न सूची समूह में प्रकाशित हुई',
  'pages.sideBySide.publishedToPrivateGroups': 'प्रश्न सूची निजी समूहों में प्रकाशित हुई',
  'pages.sideBySide.publisherLabel': 'प्रकाशक: ',
  'pages.sideBySide.purposeFieldLabel': 'उद्देश्य',
  'pages.sideBySide.purposeLabel': 'उद्देश्य: ',
  'pages.sideBySide.questionListClonedSuccess': 'प्रश्न सूची सफलतापूर्वक प्रतिलिपि हुई',
  'pages.sideBySide.questionListCreatedSuccess': 'प्रश्न सूची सफलतापूर्वक बनाई गई',
  'pages.sideBySide.questionListDeletedSuccess': 'प्रश्न सूची सफलतापूर्वक हटाई गई',
  'pages.sideBySide.questionListNamePlaceholder': 'साथ-साथ प्रश्न सूची का नाम',
  'pages.sideBySide.questionListUpdatedSuccess': 'प्रश्न सूची सफलतापूर्वक अपडेट हुई',
  'pages.sideBySide.questionsListLabel': 'प्रश्न सूची',
  'pages.sideBySide.quickQuestionsDescription':
    'तात्कालिक प्रश्नों के एक समूह के आधार पर एक या अधिक दस्तावेज़ों की संरचित साथ-साथ तुलना तैयार करें',
  'pages.sideBySide.quickQuestionsTitle': 'त्वरित प्रश्न',
  'pages.sideBySide.rejectedTag': 'अस्वीकृत',
  'pages.sideBySide.restoreConfigurationFailed':
    'कॉन्फ़िगरेशन पुनर्स्थापित करने में विफल। कृपया पुनः प्रयास करें।',
  'pages.sideBySide.reuseButton': 'पुनः उपयोग करें',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'इस टेम्पलेट के प्रश्नों की समीक्षा करें',
  'pages.sideBySide.saveChangesButton': 'बदलाव सहेजें',
  'pages.sideBySide.selectDocumentDescription':
    'वह दस्तावेज़ चुनें जिस पर आप साथ-साथ तुलना करना चाहते हैं',
  'pages.sideBySide.selectGroupsPlaceholder': 'समूह चुनें',
  'pages.sideBySide.selectGroupsToShareDescription': 'साझा करने के लिए एक या अधिक समूह चुनें:',
  'pages.sideBySide.selectionDescription':
    'अपनी प्रश्न सूचियों के आधार पर एक या अधिक दस्तावेज़ों की संरचित साथ-साथ तुलना तैयार करें',
  'pages.sideBySide.selectionFeatureName': 'साथ-साथ तुलना',
  'pages.sideBySide.selectionTitle': 'साथ-साथ',
  'pages.sideBySide.sentForApprovalSuccess': 'प्रश्न सूची अनुमोदन के लिए भेजी गई',
  'pages.sideBySide.showQuestionsButton': 'प्रश्न दिखाएँ',
  'pages.sideBySide.startGenerateReview': 'समीक्षा तैयार करना शुरू करें',
  'pages.sideBySide.startNewSideBySideButton': 'नई साथ-साथ तुलना शुरू करें',
  'pages.sideBySide.stayButton': 'यहीं रहें',
  'pages.sideBySide.submitFailed': 'साथ-साथ तुलना सबमिट करने में विफल',
  'pages.sideBySide.systemPromptLabel': 'सिस्टम प्रॉम्प्ट',
  'pages.sideBySide.tabs.prompts': 'प्रॉम्प्ट',
  'pages.sideBySide.tabs.questionList': 'प्रश्न सूची',
  'pages.sideBySide.tabs.selectDocuments': 'दस्तावेज़ चुनें',
  'pages.sideBySide.targetAudiencePlaceholder': 'क्लाइंट या लक्षित दर्शक का नाम',
  'pages.sideBySide.teamsButton': 'Teams',
  'pages.sideBySide.templateSystemPromptLabel': 'टेम्पलेट सिस्टम प्रॉम्प्ट',
  'pages.sideBySide.tour.noHistorySessions':
    'इतिहास में कोई साथ-साथ सत्र उपलब्ध नहीं है। यह चरण देखने के लिए कृपया पहले एक बनाएँ।',
  'pages.sideBySide.tour.step1.description':
    'उपलब्ध श्रेणियों में से कोई प्रश्न सूची चुनकर शुरुआत करें। आगे बढ़ने के लिए किसी भी प्रश्न सूची कार्ड पर क्लिक करें।',
  'pages.sideBySide.tour.step1.title': 'प्रश्न सूची चुनें',
  'pages.sideBySide.tour.step2.description':
    'लक्षित दर्शक या क्लाइंट का नाम दर्ज करें, फिर वह दस्तावेज़ चुनें जिसकी आप साथ-साथ तुलना करना चाहते हैं।',
  'pages.sideBySide.tour.step2.title': 'लक्षित दर्शक भरें और फ़ाइल चुनें',
  'pages.sideBySide.tour.step3.description':
    'यहाँ सिस्टम प्रॉम्प्ट और प्रश्न सूची की समीक्षा करें। पिछले सत्र देखने के लिए इतिहास पैनल पर जाएँ।',
  'pages.sideBySide.tour.step3.title': 'सिस्टम प्रॉम्प्ट और प्रश्न देखें',
  'pages.sideBySide.tour.step4.description':
    'सबमिट करने के बाद, साथ-साथ तुलना के परिणाम एक तालिका में दिखाई देंगे। विवरण देखने के लिए किसी सेल पर क्लिक करें।',
  'pages.sideBySide.tour.step4.title': 'साथ-साथ तुलना के परिणाम देखें',
  'pages.sideBySide.typeHerePlaceholder': 'यहाँ लिखें...',
  'pages.sideBySide.undoChangesButton': 'बदलाव पूर्ववत करें',
  'pages.sideBySide.unsavedChangesWillBeLost': 'कोई भी बिना सहेजे बदलाव खो जाएँगे।',
  'pages.sideBySide.untitled': '(शीर्षकहीन)',
  'pages.sideBySide.updateCellFailed': 'सेल अपडेट करने में विफल',
  'pages.sideBySide.updateCellVerificationFailed': 'सेल सत्यापन अपडेट करने में विफल',
  'pages.sideBySide.updateFailed': 'अपडेट करने में विफल',
  'pages.sideBySide.uploadDocumentFailed': 'दस्तावेज़ अपलोड करने में विफल',
  'pages.sideBySide.whatsNewDescription':
    'आपकी दस्तावेज़ साथ-साथ तुलना प्रक्रिया को बेहतर बनाने के लिए कई नई सुविधाएँ जोड़ी गईं।',
  'pages.sideBySide.whoIsItForQuestion': '1. यह किसके लिए है?',
};
